import AppHeader from "../../layout/AppHeader";
import Bank from '../../xpost/views/register/bank/Bank.vue';
import BankAdd from '../../xpost/views/register/bank/BankAdd.vue';

const BankRoutes = [
    {
        path: "/cadastro/banco",
        name: "bank",
        components: {
            header: AppHeader,
            default: Bank,
        }
    },
    {
        path: "/cadastro/banco/adicionar",
        name: "bank.add",
        components: {
            header: AppHeader,
            default: BankAdd,
        }
    },
    {
        path: '/cadastro/banco/adicionar/:id',
        name: 'bank.edit',
        components: {
            header: AppHeader,
            default: BankAdd,
        }
    }
]

export default BankRoutes;